var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1305 10.0526C21.1305 7.81442 19.2813 6 17.0003 6C14.7193 6 12.8701 7.81442 12.8701 10.0526V14.6842C12.8701 16.9224 14.7193 18.7368 17.0003 18.7368C19.2813 18.7368 21.1305 16.9224 21.1305 14.6842V10.0526Z",
    fill: "#92929E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0183 15.8423C23.6049 15.8423 24.0898 16.3124 23.9859 16.8789C23.898 17.3583 23.7491 17.8283 23.5414 18.2794C23.1855 19.052 22.664 19.7541 22.0065 20.3455C21.3491 20.9368 20.5686 21.4059 19.7095 21.7259C18.8504 22.0459 17.9298 22.2107 17 22.2107C16.0702 22.2107 15.1495 22.0459 14.2905 21.7259C13.4315 21.4059 12.6509 20.9368 11.9935 20.3455C11.336 19.7541 10.8144 19.052 10.4586 18.2794C10.2509 17.8283 10.102 17.3583 10.0141 16.8789C9.91021 16.3124 10.3952 15.8423 10.9817 15.8423C11.5683 15.8423 12.0309 16.3161 12.1781 16.8732C12.2389 17.1031 12.32 17.3289 12.421 17.5482C12.6701 18.0891 13.0352 18.5806 13.4954 18.9945C13.9556 19.4085 14.502 19.7369 15.1033 19.9608C15.7046 20.1849 16.3491 20.3002 17 20.3002C17.6509 20.3002 18.2953 20.1849 18.8967 19.9608C19.4979 19.7369 20.0443 19.4085 20.5045 18.9945C20.9649 18.5806 21.3298 18.0891 21.579 17.5482C21.68 17.3289 21.7612 17.1031 21.8218 16.8732C21.9691 16.3161 22.4317 15.8423 23.0183 15.8423Z",
    fill: "#92929E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1804 21.0527H15.8203V25.6843H18.1804V21.0527Z",
    fill: "#92929E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5406 25.6841H13.4603C12.8086 25.6841 12.2803 26.2025 12.2803 26.842C12.2803 27.4815 12.8086 27.9999 13.4603 27.9999H20.5406C21.1924 27.9999 21.7207 27.4815 21.7207 26.842C21.7207 26.2025 21.1924 25.6841 20.5406 25.6841Z",
    fill: "#92929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAma);
export default __webpack_public_path__ + "static/media/ama.ded9d05e5f4236d55f51f535f0f00485.svg";
export { ForwardRef as ReactComponent };